<template>
  <div class="promote flex flex-y relative" v-bind:style="{ paddingTop }">
    <div class="width-full text-0 absolute" style="top: 0px">
      <img
        class="width-full"
        ref="custom"
        src="@/assets/images/promote/user/bg-qrcode.png?time=123456"
        alt="邀请车主奖13元现金"
        @load="handleContent"
      />
      <button class="absolute text-14 text-white" @click="handleRule">
        活动规则
      </button>
    </div>
    <div class="content text-14 relative" style="z-index: 1">
      <div class="invite">
        <div class="qrcode text-center" style="color: #ffeae0">
          <div>长按保存图片分享给好友 好友扫码领取奖励</div>
          <div class="padding-tb-20">
            <vue-qr ref="qr" :text="url" :margin="15" />
          </div>
        </div>
      </div>
      <a class="driverQrImg" style="visibility: hidden" />
      <button @click="onDownload">
        <img
          class="width-full"
          src="@/assets/images/promote/user/btn-qrcode.png"
          alt=""
        />
      </button>
    </div>

    <canvas ref="canvas" :width="width" :height="height" v-show="false">
      你的浏览器不支持canvas！
    </canvas>
    <van-popup v-model="show" style="width: 60%; background-color: transparent">
      <div class="flex-y align-center">
        <img v-if="postUrl" :src="postUrl" alt="" srcset="" />
        <div class="bg-primary text-white margin-top-20 padding-tb-4 padding-lr-16 text-16" style="border-radius: 20px;">长按图片保存</div>
        <div class="text-white text-30 margin-top-16">
           <van-icon name="close" @click="show = false" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Popup } from 'vant'
import VueQr from 'vue-qr'
import { ossUrl, handleApp } from '@/utils/handle_app'

Vue.use(Popup)

export default {
  data () {
    const { userId } = this.$store.state.auth

    return {
      paddingTop: '59.9315vh',
      params: {
        mobile: '',
        vert: ''
      },
      isMiniprogram: window.__wxjs_environment === 'miniprogram',
      url: `${ossUrl}/#/promote/user/register?userId=${userId}`,
      width: 375,
      height: 730,
      show: false,
      postUrl: ''
    }
  },
  components: { VueQr },
  methods: {
    onDownload () {
      const url = this.$refs.qr.$el.src
      const a = document.querySelector('.driverQrImg')
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      const coverImage = new Image()
      coverImage.src = require('@/assets/images/promote/user/bg-qrcode.png')
      coverImage.onload = () => {
        ctx.drawImage(coverImage, 0, 0, this.width, this.height)
        const qrImage = new Image()
        qrImage.src = url
        qrImage.onload = () => {
          ctx.drawImage(qrImage, 116, 540, 142, 142)
          ctx.fillStyle = '#ffffff'
          ctx.font = '14px sans-serif'
          ctx.textAlign = 'center'
          ctx.fillText('好友扫码领取奖励', 188, 500, 142, 142)
          const imgUrl = canvas.toDataURL('image/jpeg', 1)
          handleApp('saveImg', { url: imgUrl }, (params, flag) => {
            if (flag) {
              this.postUrl = imgUrl
              this.show = true
            } else {
              a.download = '邀请好友' + new Date().getTime()
              a.href = imgUrl
              a.dispatchEvent(new MouseEvent('click'))
            }
          })
        }
      }
    },
    handleInvite () {
      this.$router.push('/promote/custom')
    },
    handleRule () {
      this.$router.push('/agreement/detail/21165000000004')
    },
    handleContent () {
      const height = this.$refs.custom.clientHeight
      this.paddingTop = Math.floor(height * 0.585 * 10000) / 10000 + 'px'
    },
    resizing () {
      this.ticking = false
      this.handleContent()
    },
    onResize () {
      if (!this.ticking) {
        window.requestAnimationFrame(this.resizing)
        this.ticking = true
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize, false)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize, false)
  }
}
</script>

<style lang="scss" scoped>
.promote {
  min-height: 100vh;
  overflow: hidden;
  background-color: #ff8f0a;

  button,
  input {
    padding: 0px;
    margin: 0px;
    outline: none;
    border: none;
    background-color: transparent;
  }

  .text-0 {
    font-size: 0px;
  }

  .text-500 {
    font-weight: 500;
  }

  .text-17 {
    font-size: 17px;
  }

  .text-11 {
    font-size: 11px;
    color: #ffaa93;
  }

  .text-700 {
    font-weight: 700;
    font-size: 25px;
    font-family: DIN Alternate, DIN Alternate-Bold;
  }

  img + button.absolute {
    width: 85px;
    height: 30px;
    right: 0px;
    top: 4.2465%;
    background-color: rgba(255, 255, 255, 0.22);
    border-radius: 15px 0px 0px 15px;
  }

  .content {
    padding: 10px 16px 40px;

    .invite {
      width: calc(100% + 6px);
      padding: 3px;
      position: relative;
      border-radius: 13px;
      overflow: hidden;

      &::before {
        content: "";
        width: 100%;
        height: 105px;
        display: block;
        background: linear-gradient(0deg, #ffab46 0%, #ffdfb1 100%);
        position: absolute;
        top: 0px;
        left: 0px;
      }

      & > div {
        position: relative;
        padding: 20px 6px 0px;
        border-radius: 13px;
        overflow: hidden;
        z-index: 2;

        & > div {
          position: relative;
          z-index: 2;
        }

        &::before {
          content: "";
          width: 100%;
          height: 99px;
          display: block;
          background: linear-gradient(180deg, #ff8502 0%, #ffab46 100%);
          position: absolute;
          top: 0px;
          left: 0px;
        }
      }
    }

    .qrcode {
      padding-top: 25px;

      img {
        width: 37.8%;
        border-radius: 4px;
      }
    }
  }
}
</style>
